<template>
  <div class="text-center">
    <form accept-charset="UTF-8" role="form" @submit.stop.prevent="handleSubmit">
      <h2>{{ title }}</h2>
      <p class="text-muted">{{ msg }}</p>
      <div class="alert alert-success" v-show="successMessage">
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" v-show="errorMessage">
        {{ errorMessage }}
      </div>

      <fieldset>
        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-key"></i></span>
          <input name="currentPassword" class="form-control" placeholder="current password" type="password" v-model="currentPassword" min="6"
                 v-validate="'required'"
                 data-vv-as="current password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('currentPassword')" class="invalid-feedback">{{ validate_errors.first('currentPassword') }}</div>
        </div>

        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPassword" class="form-control" placeholder="new password" type="password" v-model="newPassword" min="8"
                 v-validate="'required|min:8|contains_alpha_lower|contains_alpha_upper|contains_number'"
                 data-vv-as="new password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPassword')" class="invalid-feedback">{{ validate_errors.first('newPassword') }}</div>
        </div>

        <div class="input-group mb-3">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPasswordConfirmation" class="form-control" placeholder="confirm password" type="password"
                 v-model="newPasswordConfirmation" min="8"
                 v-validate="'required|confirmed:newPassword'"
                 data-vv-as="confirm password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPasswordConfirmation')" class="invalid-feedback">{{ validate_errors.first('newPasswordConfirmation') }}</div>
        </div>

        <div class="input-group text-center">
        <p class="text-muted mx-auto">{{ this.$passwordRequirements }}</p>
        </div>


        <div class="row mt-3">
          <div class="col-sm-6 text-sm-left text-center">
            <input class="btn btn-primary px-4" type="submit" value="Save New Password"
               :disabled="protectedUI || !formIsValid || disableAllInputs">
          </div>
          <div class="col-sm-6 text-sm-right text-center">
            <router-link to="/" class="btn btn-link px-0">Cancel</router-link>
          </div>
        </div>

      </fieldset>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'ChangePassword',
    data: () => ({
      title: 'Change Password',
      msg: 'Please provide your current password and then set your new password.',
      errorMessage: null,
      successMessage: null,
      disableAllInputs: false,
      protectedUI: false,
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    }),
    methods: {
      handleSubmit () {
        // Remove alert boxes
        this.successMessage = null
        this.errorMessage = null

        this.protectedUI = true
        this.$store.dispatch('changePassword', {
          oldPassword: this.currentPassword,
          newPassword: this.newPassword
        }).then(() => {
          this.disableAllInputs = true
          this.successMessage = 'Password successfully changed'
        }).catch((err) => {
          this.errorMessage = err.message
          this.protectedUI = false
          this.$raven.captureException(err)
        })
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      }
    },
    computed: {
      formIsValid () {
        return Object.keys(this.fields).every(key => this.fields[key].valid)
      }
    }
  }
</script>

<style scoped>
  .input-group {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .input-group input.form-control {
    width: 70%;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/ChangePassword.vue?08c8b414